import React, { FC } from 'react';

import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';

import { BackArrowHistory } from 'components/navigation/back-arrow';
import { PageWrapper } from 'components/page-wrapper';
import AuthRequired from 'pages/authentication/auth-required';

import { LoyaltyHistory } from '../loyalty/loyalty-history';

const History: FC = () => {
  const { formatMessage } = useIntl();

  return (
    <div>
      <Helmet title={formatMessage({ id: 'history' })} />
      <PageWrapper>
        <AuthRequired>
          <BackArrowHistory />
          <LoyaltyHistory />
        </AuthRequired>
      </PageWrapper>
    </div>
  );
};

export default History;
